module.exports = __webpack_public_path__ + "static/media/interactive.ed3cb5b6.png";